import { getAuthAxiosBackend } from "@/helpers/axios"

class ArchiveServices{

    getByPersonId(personId){
        return getAuthAxiosBackend().get('Files/getFileByPersonId/' + personId)
    }

    add(data){
        return getAuthAxiosBackend().post('Files/uploadFile', data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('Files/softDeleteFile/' + id)
    }
}

export default new ArchiveServices()